// extracted by mini-css-extract-plugin
module.exports = {"text":"captionSkins-small-text-4af57d7b"};